import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ActionsCompact from "./actions-compact";
import InCallIndicator from "@/modules/common/components/ui-kit/in-call-indicator";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

interface PhoneFieldProps {
  phoneNumber?: string;
  doNotCall?: boolean;
  isOnCall?: boolean;
  agentName?: string;
}

const PhoneField = ({ phoneNumber, doNotCall, isOnCall, agentName }: PhoneFieldProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: theme.nawy.spacing.sm,
        border: `1px solid ${theme.nawy.colors.primitives.navy[100]}`,
        padding: `${theme.nawy.spacing.sm} ${theme.nawy.spacing.md}`,
        borderRadius: theme.nawy.spacing.md,
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <Typography
            sx={{
              color: theme.nawy.colors.primitives.grey[700],
              ...theme.nawy.typography.english.variants.body.sm.regular,
            }}
          >
            Primary number
          </Typography>
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.accent,
              ...theme.nawy.typography.english.variants.body.lg.regular,
            }}
          >
            {doNotCall ? "Hidden" : phoneNumber || "Not set"}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <PermissionGuard
            permissions={[
              {
                name: PermissionsEnum.CAN_VIEW_IN_CALL_TAG,
                level: PermissionLevel.READ,
              },
            ]}
          >
            {isOnCall && <InCallIndicator agentName={agentName} variant="secondary" />}
          </PermissionGuard>
          <ActionsCompact phoneNumber={phoneNumber} doNotCall={!!doNotCall} />
        </Box>
      </Box>
    </Box>
  );
};

export default PhoneField;
